import _calculateResponsiveState from './calculateResponsiveState';
export { _calculateResponsiveState as calculateResponsiveState };


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-responsive/lib/actions/creators/index.js
// module id = 562
// module chunks = 2